import { render, staticRenderFns } from "./BullVaccination.vue?vue&type=template&id=cb6729c6&scoped=true&"
import script from "./BullVaccination.vue?vue&type=script&lang=js&"
export * from "./BullVaccination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6729c6",
  null
  
)

export default component.exports